module.exports = __webpack_public_path__ + "img/image005.ebc0489d.jpg";